import React from 'react'
import { FormControl, TextField, Grid, Box, Button } from '@mui/material';

export const PaymentDiscount = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { DiscountForm } = Forms
    const { formState, onInputNumberChange } = DiscountForm
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const { onSubmitDiscountModal } = Actions
    

    // const { dataRequest } = dataModal
    // console.log(dataModal)
    // console.log(dataRequest)

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="discount">* Monto a exonerar</label>
                        <TextField
                            id="discount"
                            name="discount"
                            value={formState.discount}
                            onChange={onInputNumberChange}
                            size='small'
                            type="number"
                            min="0"
                            step="0.01"
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            hiddenLabel
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Box pt={4}>
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item>
                        <Button 
                            variant='contained'
                            size='small'
                            color='success'
                            sx={{ marginRight: '8px' }}
                            onClick={onSubmitDiscountModal}
                            // onClick={
                            //     () => onSubmitDiscountModal({
                            //         itemData: dataModal.dataRequest.data,
                            //         formStateDetailsName: 'paymentExemptionDetails'
                            //     })
                            // }
                            disabled={false}
                        >
                            MODIFICAR
                        </Button>
                    </Grid>
                    
                </Grid>
            </Box>
        </>
    )
}
